// @flow
import * as React from 'react';
import UserGeneratedTextContainer from '../UserGeneratedTextContainer';
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import './AuthorInfo.scss';

export const AuthorInfo = (props: { ugc: Ugc }) => {
  const {
    ugc: { created_date, author, location },
  } = props;

  return (
    <p className="AuthorInfo">
      Submitted on{' '}
      <span data-key="created_date">{formatDate(created_date)}</span>
      {author && (
        <span>
          {' '}
          by <UserGeneratedTextContainer data-key="author" text={author} />
        </span>
      )}
      {location && (
        <span>
          {' '}
          from{' '}
          <UserGeneratedTextContainer data-key="location" text={location} />
        </span>
      )}
    </p>
  );
};

function formatDate(isoDateString: ?string) {
  return typeof isoDateString === 'string'
    ? format(parse(isoDateString), 'M/DD/YYYY h:mm A')
    : '';
}



// WEBPACK FOOTER //
// ./src/components/ContentSection/__future__/AuthorInfo.js